module.exports = __webpack_public_path__ + "img/sipka_doprava.c849a681.png";